import { Nav } from "reactstrap";
import Layout from "../../../components/custom/Layout";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { useState } from "react";
import { TabContent } from "reactstrap";
import { TabPane } from "reactstrap";
import DamageReporting from "./DamageReport";
import RampReport from "./RampReport";

export type Tab = 'DAMAGE' | 'RAMP';

export const TABS: Array<{
    name: string;
    id: Tab;
}> = [{
    name: 'DAMAGE REPORT',
    id: 'DAMAGE'
}, {
    name: 'RAMP REPORT',
    id: 'RAMP'
}];

export default function VisualReporting() {

    const [activeTab, setActiveTab] = useState<Tab>('DAMAGE');
    const toggleTab = (tab: Tab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs mb-5'}>
                <CustomNavItem<Tab>
                    tabName={'DAMAGE REPORT'}
                    tabId={'DAMAGE'}
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName={'RAMP REPORT'}
                    tabId={'RAMP'}
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId={'DAMAGE'}>
                    <DamageReporting 
                        activeTab={activeTab}
                    />
                </TabPane>
                <TabPane tabId={'RAMP'}>
                    <RampReport 
                        activeTab={activeTab}
                    />
                </TabPane>
            </TabContent>
        </Layout>
    );
}